// Central data-testid catalog. Kept as flat strings for easy grep.
export const T = {
  // Navigation
  header: "header-main",
  logoLink: "nav-logo-link",
  navLink: (slug) => `nav-link-${slug}`,
  mobileMenuToggle: "mobile-menu-toggle",
  mobileMenu: "mobile-menu",
  utilityBar: "utility-bar",
  langSelector: "lang-selector",
  bibleTranslationSelector: "bible-translation-selector",
  searchInput: "utility-search-input",
  searchSubmit: "utility-search-submit",
  elderLoginLink: "elder-login-link",
  ctaDiscoverEternal: "cta-discover-eternal-life",
  ctaNewToChristianity: "cta-new-to-christianity",

  // Homepage sections
  heroSection: "home-hero",
  heroPrimaryCta: "hero-primary-cta",
  heroSecondaryCta: "hero-secondary-cta",
  scriptureFeature: "home-scripture-feature",
  scriptureTab: (code) => `scripture-tab-${code}`,
  pathwayCards: "home-pathway-cards",
  pathwayCard: (slug) => `pathway-card-${slug}`,
  gospelSixTruths: "home-gospel-six-truths",
  gospelTruth: (n) => `gospel-truth-${n}`,
  whoIsJesus: "home-who-is-jesus",
  questionsFeature: "home-questions",
  questionCard: (slug) => `question-card-${slug}`,
  latestArticles: "home-latest-articles",
  articleCard: (slug) => `article-card-${slug}`,
  bibleStudies: "home-bible-studies",
  studyCard: (slug) => `study-card-${slug}`,
  hindiContent: "home-hindi-content",
  kidsFeature: "home-kids-feature",
  storybookCard: (slug) => `storybook-card-${slug}`,
  askPray: "home-ask-pray",
  askQuestionBtn: "ask-question-btn",
  requestPrayerBtn: "request-prayer-btn",
  trustSection: "home-trust-section",
  newsletterForm: "home-newsletter-form",
  newsletterEmail: "newsletter-email-input",
  newsletterConsent: "newsletter-consent-checkbox",
  newsletterSubmit: "newsletter-submit-btn",

  // Footer
  footer: "site-footer",
  footerLink: (slug) => `footer-link-${slug}`,

  // Article detail
  articleTitle: "article-title",
  articleBody: "article-body",
  articleTOC: "article-toc",
  articleContextBox: "article-context-box",
  articleDoesNotMean: "article-does-not-mean-box",
  articleReflection: "article-reflection",
  articleReportBtn: "article-report-btn",

  // Forms
  contactForm: "contact-form",
  contactName: "contact-name",
  contactEmail: "contact-email",
  contactSubject: "contact-subject",
  contactMessage: "contact-message",
  contactConsent: "contact-consent",
  contactSubmit: "contact-submit",
  askForm: "ask-form",
  askEmail: "ask-email",
  askQuestion: "ask-question",
  askSubmit: "ask-submit",
  prayerForm: "prayer-form",
  prayerName: "prayer-name",
  prayerText: "prayer-text",
  prayerUrgent: "prayer-urgent",
  prayerConsent: "prayer-consent",
  prayerSubmit: "prayer-submit",

  // Elder / CMS
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  loginForgot: "login-forgot-link",
  cmsSidebar: "cms-sidebar",
  cmsNav: (slug) => `cms-nav-${slug}`,
  cmsLogout: "cms-logout",
  cmsUserBadge: "cms-user-badge",
  cmsArticlesTable: "cms-articles-table",
  cmsArticleRow: (id) => `cms-article-row-${id}`,
  cmsNewArticleBtn: "cms-new-article-btn",
  cmsArticleEditor: "cms-article-editor",
  cmsField: (name) => `cms-field-${name}`,
  cmsStatusSelect: "cms-status-select",
  cmsSaveBtn: "cms-save-btn",
  cmsPublishBtn: "cms-publish-btn",

  // Kids
  kidsAgeFilter: (age) => `kids-age-filter-${age}`,
  kidsGrid: "kids-story-grid",

  // Search
  searchResultItem: (idx) => `search-result-${idx}`,
};
